import classNames from 'classnames';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { FlexRow } from 'ui-components/components/flex/row';
import { FlexColumn } from 'ui-components/components/flex/column';
import { GridHeaderWithOverflow } from '../../../../../components/grid-header/grid-header-with-overflow';
import { useInventoryReorderingFeatureGate } from '../../../../../feature-gates/use-inventory-reordering-feature-gate';
import { useTransferOrdersGridContext } from '../../data/transfer-orders-context';
import { TransferOrderGrid } from '../../grid/transfer-orders-grid';
import { AddTransferOrderButton } from '../add-transfer-order/add-transfer-order-button';
import { TransferOrderEmptyState } from '../transfer-order-empty-state/transfer-order-empty-state';
import { TransferOrdersPagingWrapper } from '../transfer-orders-paging-wrapper/transfer-orders-paging-wrapper';
import { messages } from './messages';
import style from './styles.module.less';

const label = <FormattedMessage {...messages.transferOrdersGridLabel} />;
const headerId = 'transferOrdersGridHeader';

export const TransferOrdersListPage = () => {
  const { isFeatureEnabled: isInventoryReorderingEnabled } = useInventoryReorderingFeatureGate();
  const buttons = useMemo(
    () => [<AddTransferOrderButton key={headerId} disabled={!isInventoryReorderingEnabled} />],
    [isInventoryReorderingEnabled],
  );
  const view = useMemo(() => ({ id: headerId, buttons, label }), [buttons]);
  const { data, isLoading, totalRecords, selectedIds, setSelectedIds } = useTransferOrdersGridContext();

  if (!isInventoryReorderingEnabled) {
    return <TransferOrderEmptyState view={view} />;
  }

  return (
    <FlexColumn className={style['main-content']}>
      <FlexRow className={style['grid-header']}>
        <GridHeaderWithOverflow view={view} />
      </FlexRow>
      <FlexRow className={style['edit-grid-wrap-no-filters']}>
        <>{/* TODO: Add filter bar here in ticket SPD-24957*/}</>
      </FlexRow>
      <FlexRow className={style['grid-content']}>
        <FlexColumn className={classNames(style['grid-and-footer'], style['no-sidebar'])}>
          <TransferOrderGrid data={data} isLoading={isLoading} onSelectedChanged={setSelectedIds} selected={selectedIds} />
          <TransferOrdersPagingWrapper totalRecords={totalRecords} />
        </FlexColumn>
      </FlexRow>
    </FlexColumn>
  );
};
